export default {
  data() {
    return {
      clockTickDuration: 1000,
    };
  },

  watch: {
    clockTickDuration() {
      this.stopTimer();
      this.startTimer();
    },
  },

  methods: {
    startTimer() {
      if (this.timerInterval) return;
      this.timerInterval = setInterval(() => {
        if (this.onClockTick) this.onClockTick();
      }, this.clockTickDuration);
    },

    stopTimer() {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    },
  },

  created() {
    this.startTimer();
  },

  beforeDestroy() {
    this.stopTimer();
  },
};
